import { IconButton, Popover } from "@controls";
import { useLocalstorage } from "@hooks";
import { LineColumnsRegular } from "@icons";
import { useEffect } from "react";

import { TableContextType, useTableContext } from "../context";
import Select from "../select";

export default function TableColumnVisibilityToggle() {
  const { t, table, tableId } = useTableContext() as TableContextType;
  const { setState: setTableState } = table;
  const columns = table.getAllColumns();

  const [preservedColumnVisibility, setPreservedColumnVisibility] =
    useLocalstorage("TABLE-COLUMN-VISIBILITY-" + tableId?.toUpperCase(), "{}");

  useEffect(() => {
    if (!tableId) return;
    let preservedColumnVisibilityJson = {};
    try {
      preservedColumnVisibilityJson = JSON.parse(
        preservedColumnVisibility || "{}",
      );
    } catch (error) {
      console.error("Failed to parse preserved column visibility:", error);
    }

    setTableState((prev: any) => ({
      ...prev,
      columnVisibility: {
        ...prev.columnVisibility,
        ...preservedColumnVisibilityJson,
      },
    }));
  }, [preservedColumnVisibility, tableId, setTableState]);

  return (
    <Popover
      ariaLabel={t("toggleColumnVisibility")}
      trigger={
        <IconButton
          size="small"
          customIcon={<LineColumnsRegular />}
          aria-label={t("toggleColumnVisibility")}
        />
      }
      onClose={() => {
        if (!tableId) return;
        const currentColumnVisibility = table.getState().columnVisibility;
        setPreservedColumnVisibility(
          JSON.stringify(currentColumnVisibility, null, 2),
        );
      }}
    >
      <div className="flex flex-col gap-2 m-1">
        <p className="font-semibold">{t ? t("columns") : "Columns"}</p>
        <form className="space-y-2">
          {columns.map((column) => {
            const columnTitle: string =
              typeof column.columnDef.header === "string"
                ? column.columnDef.header
                : column.id;

            return (
              <div key={column.id} className="flex items-center gap-2">
                <Select
                  row
                  id={column.id}
                  checked={column.getIsVisible()}
                  onChange={column.getToggleVisibilityHandler()}
                />
                <label htmlFor={column.id} className="text-sm">
                  {columnTitle}
                </label>
              </div>
            );
          })}
        </form>
      </div>
    </Popover>
  );
}
